export const isEmbeddedBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  const embeddedBrowsers = [
    'FBAN',     // Facebook App
    'FBAV',     // Facebook In-App Browser
    'Instagram', // Instagram In-App Browser
    'Snapchat',  // Snapchat In-App Browser
    'musical_ly',       // TikTok In-App Browser: "musical_ly_<version>" on iOS and Android
    'BytedanceWebview', // TikTok In-App Browser, the web view it runs on
  ];

  return embeddedBrowsers.some(keyword => userAgent.includes(keyword));
};

export default isEmbeddedBrowser;
